import React, { useRef, useEffect, useState } from 'react';
import './LanguagesSection.css';

const languages = [
  { name: 'English', native: 'English', label: 'Languages', level: 'Fluent' },
  { name: 'German', native: 'Deutsch', label: 'Sprache', level: 'A1 Beginner' },
  { name: 'Nepali', native: 'नेपाली', label: 'भाषा', level: 'Native' },
  { name: 'Hindi', native: 'हिन्दी', label: 'भाषाएँ', level: 'Basic' },
];


const LanguagesSection = () => {
  const scrollRef = useRef(null);
  const [activeIndex, setActiveIndex] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      const scrollLeft = scrollRef.current.scrollLeft;
      const width = window.innerWidth;
      const index = Math.round(scrollLeft / width) % languages.length;
      setActiveIndex(index);
    };

    const interval = setInterval(() => {
      if (!scrollRef.current) return;
      const width = window.innerWidth;
      const nextIndex = (activeIndex + 1) % languages.length;
      scrollRef.current.scrollTo({
        left: nextIndex * width,
        behavior: 'smooth',
      });
      setActiveIndex(nextIndex);

    }, 1500);

    const container = scrollRef.current;
    container.addEventListener('scroll', handleScroll);

    return () => {
      container.removeEventListener('scroll', handleScroll);
      clearInterval(interval);
    };
  }, [activeIndex]);

  const isDark = activeIndex % 2 !== 0;

  return (
    <section className="languages-section">
      <h2
        className={`languages-title`}
        style={{ color: isDark ? '#ffffff' : '#1e293b' }}
      >
        {languages[activeIndex]?.label}
      </h2>

      <div className="languages-scroll-container" ref={scrollRef}>
        {[...languages].map((lang, index) => (
          <div key={index} className={`language-tab ${index % 2 === 0 ? 'white' : 'dark'}`}>
          <h3 className="language-name">{lang.name}</h3>
          <p className="language-native">{lang.native}</p>
          <p className="language-level">{lang.level}</p>
        </div>
        
        ))}
      </div>
    </section>
  );
};

export default LanguagesSection;
